import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import REPLAY_PLAYER_SCHEMA_MD from '../docs/replayPlayerSchemaContent';
import './ReplayPlayerSchemaView.css';

function ReplayPlayerSchemaView() {
  return (
    <div className="replay-schema-view">
      <div className="replay-schema-header">
        <h2>Схема данных replay player</h2>
        <p>
          Откуда официальный плеер берёт камеру, добычу, army value, апгрейды и потери —
          и что уже есть в ParsedGame.
        </p>
      </div>
      <article className="replay-schema-content">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>
          {REPLAY_PLAYER_SCHEMA_MD}
        </ReactMarkdown>
      </article>
    </div>
  );
}

export default ReplayPlayerSchemaView;
